<script>

import Logo from '@/assets/imgs/frl_logo_greyblue.png'
import helpImageEn from '@/assets/imgs/help-image-en.png'
import helpImageEs from '@/assets/imgs/help-image-es.png'
import helpImageFr from '@/assets/imgs/help-image-fr.png'

export default {
  name: 'HelpScreens',
  data(){
    return{
      current:1
    }
  },
  methods:{
    closeHelpScreen(){
      localStorage.setItem('helpScreen', "invisible");
      this.$emit('hideHelpScreen')
    }
  },
  setup: () => ({
    Logo,
    helpImageEn,
    helpImageEs,
    helpImageFr
  })
}
</script>

<template>
<div class="help-screen-page">
  <div class="help-screen-text h-full overflow-y-auto custom-scrollbar text-fb-navy-2" v-if="current === 1">
    <div class="help-screen-text-dialog d-flex align-items-center py-8">
      <div class="help-screen-text-container mx-auto">
        <div class="text-center mb-4">
          <img class="help-screen-logo" :src="Logo" alt="frl_logo"/>
        </div>
        <h2 class="mb-8">{{$t('helpPage.textPage.title')}}</h2>
        <div v-html="$t('helpPage.textPage.content')"></div>
        <div class="mt-8 text-right">
          <v-btn
            color="white"
            size="small"
            @click="current = 2"
          >
            {{$t('buttons.next')}}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
  <div v-if="current === 2" class="help-screen-controls font-size-14 text-white">
    <div class="help-screen-controls-row-1 d-flex justify-space-between align-items-center">
      <div class="help-context-calender">
        <div class="d-flex align-items-center">
          <svg class="mr-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="5" y1="12" x2="19" y2="12" />
            <line x1="5" y1="12" x2="9" y2="16" />
            <line x1="5" y1="12" x2="9" y2="8" />
          </svg>
          <span>{{$t('helpPage.eventScedule.title')}}</span>
        </div>
      </div>
      <div class="help-context-leaderboard">
        <div class="d-flex align-items-center">
          <svg class="mr-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="5" y1="12" x2="19" y2="12" />
            <line x1="5" y1="12" x2="9" y2="16" />
            <line x1="5" y1="12" x2="9" y2="8" />
          </svg>
          <span>{{$t('helpPage.leaderboard.title')}}</span>
        </div>
      </div>
      <div class="help-context-notification">
        <div class="d-flex align-items-center">
          <span>{{$t('helpPage.notification.title')}}</span>
          <svg class="ml-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="5" y1="12" x2="19" y2="12" />
            <line x1="15" y1="16" x2="19" y2="12" />
            <line x1="15" y1="8" x2="19" y2="12" />
          </svg>
        </div>
      </div>
    </div>
    <div class="help-screen-controls-row-2">
      <div class="help-screen-controls-row-2-col-1 d-flex flex-column justify-space-between">
        <div class="mt-4">
          <div>
            <div>
              <span>{{$t('helpPage.portalMenu.title')}}</span>
              <p class="font-size-12 text-link-2d" v-html="$t('helpPage.portalMenu.caption')"></p>
            </div>
            <svg class="mt-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="16" y1="15" x2="12" y2="19" />
              <line x1="8" y1="15" x2="12" y2="19" />
            </svg>
          </div>
        </div>
        <div>
          <div class="mb-n3">
            <div>
              <span>{{$t('helpPage.setting.title')}}</span>
              <p class="font-size-12 text-link-2d">{{$t('helpPage.setting.caption')}}</p>
            </div>
            <svg class="mt-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="16" y1="15" x2="12" y2="19" />
              <line x1="8" y1="15" x2="12" y2="19" />
            </svg>
          </div>
        </div>
      </div>
      <div class="help-screen-controls-row-2-col-2 d-flex overflow-y-auto custom-scrollbar">
        <div class="w-100 ma-auto help-screen-controls-row-2-col-2-container">
          <div class="help-frame mb-6">
             <p v-html="$t('helpPage.eventScedule.caption')"></p>
          </div>
          <div class="help-frame d-flex flex-wrap mb-6 text-center">
            <div class="w-100 mb-4">
              {{$t('helpPage.keyboardControls.title')}}
            </div>
            <div class="w-50 mb-4">
                <div class="switch-layout">
                  <div class="switch-container switch-1">
                    <p class="text-link-2d font-size-12 mb-1">{{$t('helpPage.keyboardControls.switchWASD.w')}}</p>
                    <div class="switch d-flex justify-center align-items-center">w</div>
                  </div>
                  <div class="switch-container switch-2">
                    <div class="switch d-flex justify-center align-items-center">a</div>
                    <p class="text-link-2d font-size-12 mt-1">{{$t('helpPage.keyboardControls.switchWASD.a')}}</p>
                  </div>
                  <div class="switch-container switch-3">
                    <div class="switch d-flex justify-center align-items-center">s</div>
                    <p class="text-link-2d font-size-12 mt-1">{{$t('helpPage.keyboardControls.switchWASD.s')}}</p>
                  </div>
                  <div class="switch-container switch-4">
                    <div class="switch d-flex justify-center align-items-center">d</div>
                    <p class="text-link-2d font-size-12 mt-1">{{$t('helpPage.keyboardControls.switchWASD.d')}}</p>
                  </div>
                </div>
            </div>
            <div class="w-50 mb-4">
              <div class="switch-layout">
                <div class="switch-container switch-1">
                  <p class="text-link-2d font-size-12 mb-1">{{$t('helpPage.keyboardControls.switchArrows.up')}}</p>
                  <div class="switch d-flex justify-center align-items-center">
                    <svg width="40" height="40" viewBox="0 0 24 24" stroke-width="1.5" stroke="none" fill="currentColor" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M18 15l-6 -6l-6 6h12" />
                    </svg>
                  </div>
                </div>
                <div class="switch-container switch-2">
                  <div class="switch d-flex justify-center align-items-center">
                    <svg width="40" height="40" viewBox="0 0 24 24" stroke-width="1.5" stroke="none" fill="currentColor" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M18 15l-6 -6l-6 6h12" transform="rotate(270 12 12)" />
                    </svg>
                  </div>
                  <p class="text-link-2d font-size-12 mt-1">{{$t('helpPage.keyboardControls.switchArrows.left')}}</p>
                </div>
                <div class="switch-container switch-3">
                  <div class="switch d-flex justify-center align-items-center">
                    <svg width="40" height="40" viewBox="0 0 24 24" stroke-width="1.5" stroke="none" fill="currentColor" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M18 15l-6 -6l-6 6h12" transform="rotate(180 12 12)" />
                    </svg>
                  </div>
                  <p class="text-link-2d font-size-12 mt-1">{{$t('helpPage.keyboardControls.switchArrows.down')}}</p>
                </div>
                <div class="switch-container switch-4">
                  <div class="switch d-flex justify-center align-items-center">
                    <svg width="40" height="40" viewBox="0 0 24 24" stroke-width="1.5" stroke="none" fill="currentColor" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M18 15l-6 -6l-6 6h12" transform="rotate(90 12 12)" />
                    </svg>
                  </div>
                  <p class="text-link-2d font-size-12 mt-1">{{$t('helpPage.keyboardControls.switchArrows.right')}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mx-n3">
            <div class="w-50 px-3">
              <div class="help-frame h-full text-center d-flex flex-column justify-center">
                <div class="d-flex align-items-center justify-content-center mb-4 w-full">
                  <svg width="50" height="50" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <line x1="5" y1="12" x2="9" y2="16" />
                    <line x1="5" y1="12" x2="9" y2="8" />
                  </svg>
                  <svg width="100" height="100" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <rect x="6" y="3" width="12" height="18" rx="4" />
                    <line x1="12" y1="7" x2="12" y2="11" />
                  </svg>
                  <svg width="50" height="50" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <line x1="15" y1="16" x2="19" y2="12" />
                    <line x1="15" y1="8" x2="19" y2="12" />
                  </svg>
                </div>
                <p class="w-full font-size-12">{{$t('helpPage.mouseHelp.content')}}</p>
              </div>
            </div>
            <div class="w-50 px-3">
              <div class="help-frame h-full">
                <svg width="86.902" height="95.156" viewBox="0 0 86.902 95.156"><g fill="#fff"><path data-name="Path 153" d="M20.251 13.414l-5.747-9.016a1.938 1.938 0 00-3.267 2.08l5.747 9.016a1.947 1.947 0 001.684.892 2.258 2.258 0 001.09-.3 1.986 1.986 0 00.493-2.672z"/><path data-name="Path 154" d="M13.017 32.143L4.001 37.89a1.934 1.934 0 001.09 3.567 2.258 2.258 0 001.09-.3l9.016-5.747a1.936 1.936 0 00.594-2.675 2.133 2.133 0 00-2.774-.592z"/><path data-name="Path 155" d="M38.184 20.548a2.258 2.258 0 001.09-.3l9.016-5.747a1.938 1.938 0 10-2.081-3.27l-9.016 5.747a1.936 1.936 0 00-.594 2.675 1.681 1.681 0 001.585.895z"/><path data-name="Path 156" d="M28.276 14.504h.4a1.9 1.9 0 001.883-1.585l2.378-10.5a1.983 1.983 0 10-3.864-.892l-2.382 10.5a2.135 2.135 0 001.585 2.477z"/><path data-name="Path 157" d="M12.423 24.808a1.9 1.9 0 001.883-1.585 2.017 2.017 0 00-1.486-2.378l-10.404-2.18a1.983 1.983 0 10-.892 3.864l10.5 2.279z"/><path data-name="Path 158" d="M86.833 80.195a30.713 30.713 0 01-.3-5.747c0-7.629.1-19.222-8.719-33.093l-5.35-8.422a6.377 6.377 0 00-4.062-2.873 6.294 6.294 0 00-4.954.892.1.1 0 00-.1.1 6.244 6.244 0 00-2.081 2.18 6.758 6.758 0 00-2.573-1.194 6.456 6.456 0 00-5.053.892c-.1 0-.1.1-.2.1a6.853 6.853 0 00-2.477 3.072 6.753 6.753 0 00-6.143.3c-.1 0-.2.1-.3.1a6.307 6.307 0 00-1.973 1.979l-8.526-13.574a7.2 7.2 0 00-4.557-3.169 7.032 7.032 0 00-5.449.991l-.1.1h-.1a7.2 7.2 0 00-3.168 4.555 7.032 7.032 0 00.991 5.449l14.466 22.69a11.867 11.867 0 00-2.081 1.288 10.442 10.442 0 01-1.09.694 7.9 7.9 0 00-3.369 4.756 7.766 7.766 0 00.991 5.747l5.052 7.93c.1.1.2.3.3.4 6.143 8.422 13.574 10.7 18.726 12.088a27.656 27.656 0 013.468 1.189.893.893 0 00.5.1c2.378.5 3.072 1.684 4.36 3.864l.5.694a1.947 1.947 0 001.684.892 2.258 2.258 0 001.09-.3 1.936 1.936 0 00.594-2.675l-.4-.694c-1.395-2.285-2.882-4.758-6.844-5.658a24.236 24.236 0 00-3.765-1.189c-5.152-1.486-12.187-3.567-17.637-12.187l-4.261-6.634a3.822 3.822 0 01-.5-2.774 3.476 3.476 0 011.585-2.279 10.378 10.378 0 001.09-.793 10.174 10.174 0 011.883-1.189l.4.4 5.945 9.314a1.947 1.947 0 001.684.892 2.258 2.258 0 001.09-.3 1.936 1.936 0 00.594-2.675l-5.846-9.315-16.842-26.455a3.126 3.126 0 01-.4-2.477 3.186 3.186 0 011.486-2.081l.1-.1h.1a3.126 3.126 0 012.477-.4 3.186 3.186 0 012.079 1.491l11.89 18.726 5.549 8.818a1.947 1.947 0 001.684.892 2.258 2.258 0 001.09-.3 1.936 1.936 0 00.594-2.675l-5.549-8.818a2.852 2.852 0 01.892-3.864 2.852 2.852 0 013.864.892l5.549 8.818a1.947 1.947 0 001.684.892 2.258 2.258 0 001.09-.3 1.936 1.936 0 00.594-2.675l-4.657-7.332a3.055 3.055 0 01-.4-2.081 3.189 3.189 0 011.189-1.783 3.055 3.055 0 012.081-.4 3.189 3.189 0 011.783 1.189l1.883 2.873 3.765 5.846a1.947 1.947 0 001.684.892 2.258 2.258 0 001.09-.3 1.936 1.936 0 00.594-2.675l-4.053-5.934a2.334 2.334 0 01-.3-1.982 2.706 2.706 0 011.09-1.585 2.334 2.334 0 011.982-.3 2.707 2.707 0 011.585 1.09l5.353 8.427c8.224 12.881 8.125 23.78 8.125 31.013a33.159 33.159 0 00.4 6.738 1.909 1.909 0 001.875 1.483.893.893 0 00.5-.1 1.985 1.985 0 001.485-2.377z"/></g></svg>
                <div>
                  <p class="font-size-18">{{$t('helpPage.clickHelp.title')}}</p>
                  <p class="font-size-12 mt-2">{{$t('helpPage.clickHelp.content')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="help-screen-controls-row-2-col-3 text-right d-flex flex-column">
        <div class="mt-n2">
          <svg width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="16" y1="9" x2="12" y2="5" />
            <line x1="8" y1="9" x2="12" y2="5" />
          </svg>
          <p>{{$t('helpPage.profile.title')}}</p>
        </div>
        <div class="mt-auto mb-n2">
          <div>
            <span>{{$t('helpPage.chat.title')}}</span>
            <p class="font-size-12 text-link-2d" v-html="$t('helpPage.chat.caption')"></p>
          </div>
          <svg class="mt-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="16" y1="15" x2="12" y2="19" />
              <line x1="8" y1="15" x2="12" y2="19" />
            </svg>
        </div>
      </div>
    </div>
    <div class="help-screen-controls-row-3 d-flex justify-space-between align-items-center">
      <div>
        <div class="d-flex align-items-center mb-n3">
          <svg class="mr-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="5" y1="12" x2="19" y2="12" />
            <line x1="5" y1="12" x2="9" y2="16" />
            <line x1="5" y1="12" x2="9" y2="8" />
          </svg>
          <div>
            <p>{{$t('helpPage.mute.title')}}</p>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="mb-n3 d-flex align-items-center">
          <div>
              <span>{{$t('helpPage.videoChat.title')}}</span>
          </div>
          <svg class="ml-2" width="32" height="32" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <line x1="5" y1="12" x2="19" y2="12" />
            <line x1="15" y1="16" x2="19" y2="12" />
            <line x1="15" y1="8" x2="19" y2="12" />
          </svg>
        </div>
      </div>
    </div>
    <v-btn
      color="white"
      size="small"
      class="dont-show-btn"
      @click="current = 3"
    >
      {{$t('buttons.next')}}
    </v-btn>
  </div>
  <div class="help-screen-image h-full overflow-y-auto custom-scrollbar text-fb-navy-2" v-if="current === 3">
    <img v-if="$store.state.ui.locale === 0" :src="helpImageEn" alt="help image" />
    <img v-if="$store.state.ui.locale === 1" :src="helpImageEs" alt="help image" />
    <img v-if="$store.state.ui.locale === 2" :src="helpImageFr" alt="help image" />
    <v-btn
      color="primary"
      size="small"
      class="dont-show-btn"
      @click="closeHelpScreen"
    >
      {{$t('helpPage.dontShowButton')}}
    </v-btn>
  </div>
</div>
</template>

<style lang="scss" scoped>
.help-screen-page{
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:1010;
}
.help-screen-logo{
  max-width:100px;
}
.help-screen-text{
  height: 100vh;
  background-color: rgba(var(--v-theme-white), .7);
  color: #75787b;
  &-container{
    max-width: 800px;
    width:100%;
    padding: 20px;
    h2{
      font-size: 40px;
    }
    .move-next-link{
      color: inherit;

    }
  }
}
.help-screen-text-dialog{
  min-height: 100%;
}
.help-context-leaderboard{
  position: absolute;
  top: 26px;
  left: calc(50% + 30px);
}
.help-screen-controls{
  display: grid;
  height: 100vh;
  grid-template-rows: 90px 1fr 90px;
  &-row-1{
    padding-left: 90px;
    padding-right: 150px;
  }
  &-row-2{
    display: grid;
    height: calc(100vh - 180px);
    grid-template-columns: 200px 1fr 200px;
    &-col-1{
      padding-left: 33px;
    }
    &-col-2{
      padding: 0 20px;
      &-container{
        max-width:900px;
      }
    }
    &-col-3{
      padding-right: 33px;
    }
  }
  &-row-3{
    padding-left: 150px;
    padding-right: 150px;
  }
}
.help-frame{
  border:1px solid #fff;
  background-color: rgba(var(--v-theme-black), .8);
  padding: 20px;
}
.switch-layout{
  display: inline-grid;
  grid-gap:10px;
  grid-template-columns: repeat(3, 80px);
  grid-template-rows: repeat(2, auto);
}
.switch-1{
  grid-column: 2/3;
  grid-row: 1/2;
}
.switch-2{
  grid-column: 1/2;
  grid-row: 2/3;
}
.switch-3{
  grid-column: 2/3;
  grid-row: 2/3;
}
.switch-4{
  grid-column: 3/4;
  grid-row: 2/3;
}
.switch{
  border:2px solid #fff;
  border-radius: 8px;
  height: 80px;
  font-size: 22px;
  font-weight:bold;
  text-transform: uppercase;
  svg{
    display: inline-block;
  }
}
.dont-show-btn{
  position: fixed;
  bottom: 25px;
  left:50%;
  transform: translateX(-50%);
}
.help-screen-image{
  background-color: #acd6e1;
  img{
    max-height: 100%;
    display: block;
    margin: 0 auto;
  }
}
</style>